export default {
  'meta': {
    'langName': 'DUTCH',
    'lang': 'Nederlands'
  },
  'title': 'Belangrijke veiligheidswaarschuwing TARMAK Basketbalpaal B900 BOX NBA',
  'description': 'Geachte heer/mevrouw,\n\nJe hebt onlangs een Tarmak B900 BOX NBA basketbalpaal gekocht, en we bedanken je voor deze aankoop.\n\nAls onderdeel van onze voortdurende inzet voor productkwaliteit en veiligheid, heeft het Decathlon Basketbalteam een potentieel risico vastgesteld. Het bovenste deel van de paal kan naar beneden vallen als de hendel voor hoogteverstelling wordt verwijderd en het product vervolgens wordt gehanteerd of gebruikt. Dit kan leiden tot ernstig letsel, zoals beknelling of kneuzing van handen of vingers.\n\nWij verzoeken vriendelijk om enkele vragen te beantwoorden, zodat wij de juiste veiligheidsoplossing voor het product kunnen bieden.\n\nOnze excuses voor het ongemak en wij danken je voor het vertrouwen.\n\nTeam Decathlon',
  'emailConfirmation': {
    'title': 'Kun je eerst jouw e-mailadres en land van verblijf bevestigen?'
  },
  'fields': {
    'country': 'Land',
    'address': 'E-mailadres',
    'email': 'E-mailadres',
    'phonePrefix': 'Landcode telefoon',
    'phone': 'Telefoonnummer',
    'validations': {
      'phoneOrEmail': 'Geef ten minste een e-mailadres of telefoonnummer op.',
      'email': 'Voer een geldig e-maildres in',
      'phone': 'Voer een geldig telefoonnummer in'
    },
    'firstName': 'Achternaam',
    'lastName': 'Voornaam',
    'deliveryAddress': 'Adres',
    'additionalAddress': 'Extra adresgegevens',
    'city': 'Woonplaats',
    'zip': 'Postcode',
    'choose': 'Kies',
    'required': 'Dit veld is verplicht'
  },
  'ownerCheck': {
    'title': 'Heb je nog (steeds) één of meerdere B900 BOX NBA basketbalpalen?'
  },
  'yes': 'Ja',
  'no': 'Nee',
  'ownerChanged': {
    'title': 'Heb je de contactgegevens van de huidige eigenaar(s)?',
    'confirmation': 'Beste klant, \n\nBedankt voor je deelname aan dit kwaliteitsinitiatief.\n\nOnze excuses voor het ongemak en wij danken je voor het vertrouwen.\n\nTeam Decathlon'
  },
  'recall': {
    'title': 'Geef het aantal basketbalringen aan dat je hebt, gebaseerd op het type hendel dat is geïnstalleerd',
    'descriptionRed': 'Basketbalring met verwijderbare rode hendel',
    'descriptionBlack': 'Basketbalring met vaste zwarte hendel',
    'quantity': 'Aantal',
    'notConcerned': 'Beste klant,\n\nBedankt voor je deelname aan dit kwaliteitsinitiatief.\n\nJe kunt ervan op aan dat jouw Tarmak B900 BOX NBA basketbalpaal niet getroffen is door deze actie. Deze kun je veilig gebruiken.\n\nOnze excuses voor het eventuele ongemak en wij danken je voor het vertrouwen.\n\nDecathlon',
    'concernedProductQuantity': 'Niet-conforme producthoeveelheid:',
    'concernedProductLabel': 'Non conform product:',
    'confirmation': 'Bedankt voor het invullen van dit formulier. Jouw aanvraag is succesvol geregistreerd.\n\nWij sturen zo snel mogelijk de track & trace code voor de levering van de reparatieset (via FandiWeb voor Europese landen / via X voor niet-Europese landen).\n\nEen fijne dag gewenst,\n\nTeam Decathlon'
  },
  'repair': {
    'title': 'Reparatie met jouw hulp',
    'description': 'Wij hebben een risico vastgesteld dat het bovenste deel van de paal naar beneden kan vallen als de hendel wordt verwijderd, en het product wordt gehanteerd of gebruikt bij bepaalde TARMAK B900 BOX NBA basketbalpalen, ref. 4239136.\nOp basis van jouw antwoord blijkt het product door dit risico te zijn getroffen.\n\nWij verzoeken per direct het product niet meer te gebruiken, en bieden onze hulp aan bij het aanpassen van de hendel, zodat je het product veilig kunt gebruiken.\nWees gerust, voor deze reparatie is geen speciale kennis nodig — alles wordt duidelijk uitgelegd in de onderstaande video en handleiding:',
    'videoLink': 'Link naar de video',
    'docLink': 'Link naar de handleiding',
    'callToAction': 'Klik hier om de gratis reparatieset te ontvangen',
    'warranty': 'Het gehele proces wordt gedekt door onze garantie van 5 jaar.'
  },
  'repairRequest': {
    'title': 'Voer de volgende informatie in, zodat de reparatieset gratis naar het adres van jouw keuze kan worden verzonden:'
  },
  'form': {
    'submit': 'Volgende'
  },
  'status': 'Translation validated by COUNTRY'
} as const
